import request from '@/utils/request'

/**
 * 获取所有印章规则
 */
export function getSealRules() {
  return request({
    url: '/signstore/sealrule/list',
    method: 'get'
  })
}

/**
 * 对比印章点位相似度（统一打卡接口）
 * @param {Object} data - 包含 ruleCode、touchPoints 和可选的 activityUserId
 */
export function compareSealPoints(data) {
  return request({
    url: '/signstore/sealrule/compareSimilarity',
    method: 'post',
    data: {
      ruleCode: data.ruleCode,
      touchPoints: data.touchPoints,
      activityUserId: data.activityUserId || null,
      authStoreCode: data.authStoreCode
    }
  })
}

/**
 * 追加印章点位到规则
 * @param {Object} data - 包含 ruleCode、sealPoints（4个点位）
 */
export function addSealPoints(data) {
  return request({
    url: '/signstore/sealrule/addSealPoints',
    method: 'post',
    data: {
      ruleCode: data.ruleCode,
      sealPoints: data.sealPoints,
      coordinateSystem: data.coordinateSystem
    }
  })
}

